export default {
  navigation: 'Navigation',
  dashboard: 'Dashboard',
  resources: 'Resources',
  categories: 'Categories',
  locations: 'Locations',
  tags: 'Tags',
  borrowings: 'Borrowings',
  consumptions: 'Consumptions',
  refills: 'Refills',
  reservations: 'Reservations',
  profile: 'Profile',
  settings: 'Settings',
  admin: 'Admin',
  logout: 'Logout'
};
